/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Scrivi qualcosa…',
  'fabric.editor.editorAssistiveLabel': 'Area del contenuto principale; inizia a digitare per inserire il testo.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Apri finestra della guida'
};